import React from 'react';
import { getInstance as getBootstrap } from 'utils/bootstrap';

const bootstrap = getBootstrap();
const bootstrapFlags = bootstrap.get('flags');

export const FlagsContext = React.createContext(bootstrapFlags);

export function withFlags(Component) {
    return function ComponentWithFlags(props) {
        return <FlagsContext.Consumer>{(flags) => <Component {...props} flags={flags} />}</FlagsContext.Consumer>;
    };
}

export const useFlags = () => React.useContext(FlagsContext);
